import { ContentSection, Specialists, Directions, Hero } from '@/components';
import { StyledButton, StyledContent } from '@/components/styles';
import { useLoadMore, usePartialQuery } from '@/hooks';
import { useEffect, useMemo } from 'react';
import { useRouter } from 'next/router';
import api from '@/lib/api';
import { useTranslation } from 'react-i18next';

function calcCurrentDirection(queryDirection, directions, defaultDirection) {
  if (!queryDirection) {
    return defaultDirection;
  } else {
    const currentDirection = directions.reduce((acc, cur) => {
      return cur.slug === queryDirection ? cur : acc;
    }, null);
    return currentDirection || defaultDirection;
  }
}

export default function SpecialistsPage(props) {
  const { directions, paginator } = props;
  const { banners } = paginator;
  const router = useRouter();

  const { t } = useTranslation('global');

  const defaultDirection = {
    id: 'all',
    title: 'All directions',
    service_count: 1,
    slug: 'all',
    subdirections: [],
  };

  const q = usePartialQuery(['direction']);
  const queryParams = useMemo(() => (q?.direction || !q ? q : { direction: defaultDirection.slug }), [q]);

  const currentDirection = calcCurrentDirection(queryParams.direction, directions, defaultDirection);

  const specialistsPaginator = useLoadMore(api.specialists, paginator, queryParams);

  const handleChange = (type) => (value) => {
    const nextFilter = {};
    if (value !== 'all') {
      nextFilter[type] = value;
    }

    router.push(
      { pathname: router.pathname, query: { ...nextFilter } },
      { pathname: location.pathname, query: { ...nextFilter } },
      { shallow: true }
    );
  };

  let breadcrumbs = [
    {
      id: 1,
      title: t('main.titlePage'),
      slug: '',
      type: 'index',
    },
    {
      id: 2,
      title: t('specialists.titlePage'),
      slug: '',
      type: 'specialists',
    },
  ];

  return (
    <>
      {!!banners?.length && <Hero data={banners} center={true} size="x-mid" breadcrumbs={breadcrumbs || []} />}
      <StyledContent>
        <div style={{ overflow: 'hidden' }}>
          <StyledContent.Container>
            {!!directions?.length && (
              <Directions
                directions={[defaultDirection, ...directions]}
                active={currentDirection}
                onClick={handleChange('direction')}
                size="mid"
                center
              />
            )}
          </StyledContent.Container>
        </div>
        <StyledContent.Container>
          <StyledContent.ColumnMain>
            <StyledContent.Loadable isLoading={specialistsPaginator.loading}>
              {specialistsPaginator.items && specialistsPaginator.items.length > 0 ? (
                <ContentSection noTitle>
                  <Specialists data={specialistsPaginator.items} items={4} />
                </ContentSection>
              ) : (
                <StyledContent.Empty>{t('specialists.empty')}</StyledContent.Empty>
              )}

              {specialistsPaginator.hasMore && (
                <StyledContent.LoadBtn>
                  <StyledButton light onClick={specialistsPaginator.handleLoadMore}>
                    {t('showMore')}
                  </StyledButton>
                </StyledContent.LoadBtn>
              )}
            </StyledContent.Loadable>
          </StyledContent.ColumnMain>
        </StyledContent.Container>
      </StyledContent>
    </>
  );
}
